<template lang="pug">
IndexOriginal
</template>

<script setup>
import { useUrlModalTrigger } from '@/composables/ui/useUrlModalTrigger'
import { MODAL_INTENT } from '@/utils/urlModal'

definePageMeta({
  layout: 'default',
  middleware: 'guest',
})

// 開窗、?error= 守門、公告延後旗標統一由 composable 處理，與 /register 共用同一條路徑
// （原本 login 用 useAuthToken().token、register 用 storage.get(cuora_*)，兩頁判斷不一致）
// 規格：spec/JT-1784716920_url-modal-trigger-announcement-deferral.md
useUrlModalTrigger(MODAL_INTENT.LOGIN)
</script>
<style lang="scss" scoped></style>
